import React from "react";
import { Button } from "@mui/material";
import { RiGoogleLine, RiStore3Line  } from "@remixicon/react";
import { Tooltip } from "@mui/material";

interface ExternalLinksButtonGroupProps {
  place_id?: string;
  google_places_id?: string;
  store_url?: string;
}

const ExternalLinksButtonGroup: React.FC<ExternalLinksButtonGroupProps> = ({
  place_id,
  google_places_id,
  store_url,
}) => {
  const handleClick = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="flex gap-2">
      {google_places_id && (
        <Tooltip title="Open in Google Maps">
          <Button
            onClick={() =>
              handleClick(`https://www.google.com/maps?q=place_id:${google_places_id}`)
            }
            variant="text"
          >
            <RiGoogleLine size={18} />
          </Button>
        </Tooltip>
      )}
      {place_id && (
        <Tooltip title="View in Kuebiko">
            <Button
            onClick={() =>
                handleClick(`https://kuebiko.dataplor.com/places/${place_id}/data`)
            }
            variant="text"
            >
            <img
                src="/images/dataplor_logo.svg"
                alt="dataplor logo"
                style={{ width: 18, height: 18 }}
            />
            </Button>
        </Tooltip>
        )}
         {store_url && (
        <Tooltip title="Open Store Locator URL">
          <Button
            onClick={() => handleClick(store_url)}
            variant="text"
          >
            <RiStore3Line size={18} />
          </Button>
        </Tooltip>
      )}
    </div>
  );
};
export default ExternalLinksButtonGroup;
